<template>
	<div class="xiazai">
		<ul>
			<li
				v-for="(item, index) in dataList"
				:key="item.ID"
				@mouseenter="hoverRoll(item)"
				class="wow fadeInLeft"
				:data-wow-delay="index / 7 + 's'"
			>
				<a
				:href="item.FileUrl"
				class="flexDiv">
				<div class="textBox flexDiv">
					<span>{{ setTimeformat(item.ShowTime, "yyyy-mm-dd") }}</span>
					<p class="title txt-cut1">{{ item.Title }}</p>
				</div>
				<div class="text_img">
					<img src="../assets/img/xiazai_img.png" alt="">
				</div>
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
	export default{
		name:'noImgList',
		props:{
			dataList:{
				type: Array,
				default: () => [],
			},
			moreLink: {
			   type: String,
			   default: ''
			}
		},
		methods:{
			setTimeformat(_data,_format='yyyy-mm-dd'){
				return _format.replace(/YYYY/i,_data.substr(0,4)).replace(/MM/i,_data.substr(5,2)).replace(/DD/i,_data.substr(8,2))
			},
			hoverRoll(_data){
			    this.item = _data
			},
			// OpenLink(FileUrl){
			// 	this.item.FileUrl = FileUrl
			// }
		}
	}
</script>

<style lang='less' scoped>
.xiazai{
	width: 6.9rem;
	ul {
		width: 100%;
		height: auto;
		display: inline-block;
		vertical-align: top;
		padding: 0rem 0.3rem 0rem 0.3rem;
		box-sizing: border-box;
		li {
		width: 100%;
		height: 0.4rem;
		margin-bottom: 0.25rem;
		font-size: 0;
		border-bottom: dashed 0.01rem #e4e4e4;
		box-sizing: border-box;
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		-khtml-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		&:last-child {
			margin-bottom: 0rem;
			}
			a {
			width: 100%;
			height: 0.4rem;
			// display: flex;
			// flex-wrap: nowrap;
			// justify-content: space-between;
			.text_img {
				display: block;
				width: 0.23rem;
				height: 0.22rem;
				margin: 0;
			}
			.textBox {
			font-size: 0.26rem;
			font-weight: normal;
			font-stretch: normal;
			line-height: 0.26rem;
			letter-spacing: 0.02rem;
			color: #333333;
			padding-left: 0.1rem;
			box-sizing: border-box;
			position: relative;
			span{
				width: 1.65rem;
				display: block;
			}
			p{
				width: 3rem;
				margin-left: 0.2rem;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
				&::before {
				content: "";
				width: 0.04rem;
				height: 0.04rem;
				background-color: #333333;
				border-radius: 50%;
				display: block;
				position: absolute;
				top: 0.1rem;
				left: 0rem;
				}
			}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/noImgList.vue